import {type Channel, ChannelType} from '@mattermost/types/channels';

/**
 *
 * @deprecated используйте channel.type === ChannelType.Direct
 */
export const isDirectChannel = (channel: Channel | undefined) => {
    return channel?.type === ChannelType.Direct;
};
